import { useContext } from "react";
import StateContext from "../StateContext";
import useMediaQuery from "@material-ui/core/useMediaQuery";

function Banner(props) {
  const minDesktop = useMediaQuery("(min-width: 992px)");
  const appState = useContext(StateContext);
  if (minDesktop) {
    return (
      <>
        {/* bannerSection */}
        <div className={`bannerSection`}>
          {/* innerBanner */}
          <div className="innerBanner">
            {/* bannerImg */}
            <div
              className="bannerImg"
              style={{
                backgroundImage: `url('${process.env.REACT_APP_IMAGE_URL}banner.png')`,
              }}
            ></div>
            {/* banenrContent */}
            <div className="banenrContent">
              <div className="container">
                <h1>
                  {props.message_primary}{" "}
                  <strong>{props.message_secondary}</strong>
                </h1>
                <h5>{props.other_message}</h5>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        {/* bannerSection */}
        <div className={`bannerSection ${props.className}`}>
          {/* innerBanner */}
          <div className="innerBanner">
            {/* bannerImg */}
            <div
              className="bannerImg"
              style={{
                backgroundImage: `url('${process.env.REACT_APP_IMAGE_URL}banner.png')`,
              }}
            ></div>
            {/* banenrContent */}
            <div className="banenrContent">
              <div className="container">
                <h1>
                  {props.message_primary}{" "}
                  <strong>{props.message_secondary}</strong>
                </h1>
                <h5>{props.other_message}</h5>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Banner;
